(function () {
    "use strict";

    angular.module("app").factory("ivmRequestHelper", IvmRequestHelper);

    IvmRequestHelper.$inject = ["$filter", "enumService"];
    function IvmRequestHelper($filter, enumService) {
        const fields = {
            getTranslation: $filter("habilTranslation"),
        };

        const ivmInitialActions = enumService.IvmInitialActions;

        return {
            GetInitialActionText: getInitialActionText,
            GetInitialActionIcon: getInitialActionIcon
        };

        function getInitialActionText(request) {
            const initialAction = Number.parseInt(request.InitialAction);
        
            if (request.IsTransfer)
                return fields.getTranslation("Person_IsTransfer");
            
            switch (initialAction) {
                case ivmInitialActions.New:
                    return fields.getTranslation("RequestIVM_InitialAction_New");
                case ivmInitialActions.Change:
                    return fields.getTranslation("RequestIVM_InitialAction_Change");
                case ivmInitialActions.Renew:
                    return fields.getTranslation("RequestIVM_InitialAction_Renew");
                case ivmInitialActions.Remove:
                    return fields.getTranslation("RequestIVM_InitialAction_Remove");
            }
            return null;
        }

        function getInitialActionIcon(request) {
            if (request.IsTransfer)
                return "fa fa-exchange";

            const initialAction = Number.parseInt(request.InitialAction);

            switch (initialAction) {
                case ivmInitialActions.New:
                    return "fa fa-plus";
                case ivmInitialActions.Change:
                    return "fa fa-edit";
                case ivmInitialActions.Renew:
                    return "fa fa-repeat";
                case ivmInitialActions.Remove:
                    return "fa fa-times";
            }
            return null;
        }
    }
})();
